// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/projects/v1/create_vision_location.proto (package protos.vision.projects.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/projects/v1/create_vision_location.proto.
 */
export const file_vision_projects_v1_create_vision_location: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vcHJvamVjdHMvdjEvY3JlYXRlX3Zpc2lvbl9sb2NhdGlvbi5wcm90bxIZcHJvdG9zLnZpc2lvbi5wcm9qZWN0cy52MSKpAQobQ3JlYXRlVmlzaW9uTG9jYXRpb25SZXF1ZXN0Ek0KBnBhcmFtcxgBIAEoCzI9LnByb3Rvcy52aXNpb24ucHJvamVjdHMudjEuQ3JlYXRlVmlzaW9uTG9jYXRpb25SZXF1ZXN0LlBhcmFtcxo7CgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCRIMCgRuYW1lGAIgASgJEg8KB2FkZHJlc3MYAyABKAkijQEKHENyZWF0ZVZpc2lvbkxvY2F0aW9uUmVzcG9uc2USTgoGcmVzdWx0GAEgASgLMj4ucHJvdG9zLnZpc2lvbi5wcm9qZWN0cy52MS5DcmVhdGVWaXNpb25Mb2NhdGlvblJlc3BvbnNlLlJlc3VsdBodCgZSZXN1bHQSEwoLbG9jYXRpb25faWQYASABKAliBnByb3RvMw");

/**
 * @generated from message protos.vision.projects.v1.CreateVisionLocationRequest
 */
export type CreateVisionLocationRequest = Message<"protos.vision.projects.v1.CreateVisionLocationRequest"> & {
  /**
   * @generated from field: protos.vision.projects.v1.CreateVisionLocationRequest.Params params = 1;
   */
  params?: CreateVisionLocationRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.CreateVisionLocationRequest.
 * Use `create(CreateVisionLocationRequestSchema)` to create a new message.
 */
export const CreateVisionLocationRequestSchema: GenMessage<CreateVisionLocationRequest> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_create_vision_location, 0);

/**
 * @generated from message protos.vision.projects.v1.CreateVisionLocationRequest.Params
 */
export type CreateVisionLocationRequest_Params = Message<"protos.vision.projects.v1.CreateVisionLocationRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string address = 3;
   */
  address: string;
};

/**
 * Describes the message protos.vision.projects.v1.CreateVisionLocationRequest.Params.
 * Use `create(CreateVisionLocationRequest_ParamsSchema)` to create a new message.
 */
export const CreateVisionLocationRequest_ParamsSchema: GenMessage<CreateVisionLocationRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_create_vision_location, 0, 0);

/**
 * @generated from message protos.vision.projects.v1.CreateVisionLocationResponse
 */
export type CreateVisionLocationResponse = Message<"protos.vision.projects.v1.CreateVisionLocationResponse"> & {
  /**
   * @generated from field: protos.vision.projects.v1.CreateVisionLocationResponse.Result result = 1;
   */
  result?: CreateVisionLocationResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.CreateVisionLocationResponse.
 * Use `create(CreateVisionLocationResponseSchema)` to create a new message.
 */
export const CreateVisionLocationResponseSchema: GenMessage<CreateVisionLocationResponse> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_create_vision_location, 1);

/**
 * @generated from message protos.vision.projects.v1.CreateVisionLocationResponse.Result
 */
export type CreateVisionLocationResponse_Result = Message<"protos.vision.projects.v1.CreateVisionLocationResponse.Result"> & {
  /**
   * @generated from field: string location_id = 1;
   */
  locationId: string;
};

/**
 * Describes the message protos.vision.projects.v1.CreateVisionLocationResponse.Result.
 * Use `create(CreateVisionLocationResponse_ResultSchema)` to create a new message.
 */
export const CreateVisionLocationResponse_ResultSchema: GenMessage<CreateVisionLocationResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_create_vision_location, 1, 0);

